export default __webpack_public_path__ + "static/blanket.dark-23d537c31fd2b171079199d5225436bd1847ac4ae0e834638556f48ed2adeef2.png";